/**
 * Stripe Connect theme configuration
 * This file contains the appearance configuration for the Stripe Connect components.
 */

// Import types from @stripe/connect-js
import { AppearanceOptions } from '@stripe/connect-js';

// Define the type for the Stripe Connect appearance variables
export interface StripeConnectThemeVariables {
  colorPrimary: string;
  colorBackground: string;
  buttonPrimaryColorBackground: string;
  buttonPrimaryColorBorder: string;
  actionPrimaryColorText: string;
  actionPrimaryTextDecorationLine: string;
  actionSecondaryColorText: string;
  offsetBackgroundColor: string;
  formBackgroundColor: string;
  borderRadius: string;
  buttonBorderRadius: string;
  fontFamily: string;
  headingXlFontSize: string;
}

// Export the default theme configuration
export const stripeConnectTheme: AppearanceOptions = {
  variables: {
    colorPrimary: "#f8f9fa",
    colorBackground: "#f8f9fa",
    buttonPrimaryColorBackground: "#7b27c9",
    buttonPrimaryColorBorder: "#E8DBF5",
    actionPrimaryColorText: "#7b27c9",
    actionPrimaryTextDecorationLine: "underline",
    actionSecondaryColorText: "#7b27c9",
    offsetBackgroundColor: "#f8f9fa",
    formBackgroundColor: "#f9f9f9",
    borderRadius: "4px",
    buttonBorderRadius: "24px",
    fontFamily: "'Roboto', sans-serif",
    headingXlFontSize: "20px",
  },
  overlays: "drawer" as const
}; //https://docs.stripe.com/connect/customize-connect-embedded-components